module.exports = __webpack_public_path__ + "img/btn.c74b9a2a.png";